<template>
  <div class="container">
    <div class="title"><span>首页</span>>  预约指南</div>
    <div class="neir">
      <div class="l">
        <div class="lT">
          <ul class="list">
            <li v-for="(item, index) in pagelist" :class="active == index ? 'active': ''"  :key="item.id" @click="tab(index, item.id)">{{item.name}} <p></p></li>
          </ul>
          <ul class="neirList">
            <li :class="active2 == 'all' ? 'active': ''" @click="ejfl('all', null)">全部</li>
            <li v-for="(sitem, index) in list3" :key="sitem.id" :class="active2 == index ? 'active': ''" @click="ejfl(index, sitem.id)"> {{sitem.name}}</li>
          </ul>
        </div>
        <ul class="lB" style="margin-top: 20px;">
          <li v-for="item in pagelist2" :key="item.id" @click="info(item.id)">
            <img :src="item.picUrl" alt="">
            <div>
              <h3 class="tit">{{item.name}}</h3>
              <p class="js">
                {{item.introduction}}
              </p>
              <p class="time">{{item.createTime}}</p>
            </div>
          </li>
        </ul>
        <div class="page">
          <el-pagination
            background
            layout="pager"
            :total="total"
            @current-change="chanePage"
          >
          </el-pagination>
        </div>
      </div>
      <div class="r">
        <div class="lT">
          <ul class="list">
            <li class="active">热门PETCT/MR医院 <p></p></li>
          </ul>
        </div>
        <ul class="lB">
          <li v-for="item in list4" :key="item.id" @click="goinfo(item.id)">
            <img :src="item.picUrl" alt="">
            <div>
              <h3>{{item.name}}</h3>
              <p>{{item.introduction}} </p>
              <p>￥{{item.salesPrice}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          active2: 'all',
          pagelist: [],
          pagelist2: [],
          list3: [],
          list4: [],
          current: 1,
          total: 0,
          categorySecond: null,
          parentId: null,
          category: 0,
          active: 0
        }
    },
    methods: {
      info(id) {
        this.$router.push({
          path: `/yyznxq?id=${id}`
        })
      },
      goinfo(id) {
        this.$router.push({
          path: `/xxjs?id=${id}`
        })
      },
      tab(index,id) {
        this.active = index
        this.parentId = id
        this.list3 = this.pagelist[index].children
        this.active2 = 'all'
        this.categorySecond = null
        this.list2()
      },
      ejfl(index,id) {
        this.active2 = index
        this.categorySecond = id
        this.list2()
      },
      list() {
        server.category().then((res) => {
          this.pagelist = res.data
          this.list3 = this.pagelist[0].children
          this.parentId = this.pagelist[0].id
          this.list2()
          // this.total = res.data.total
        })
      },
      list2() {
        server.guide({
          current: this.current,
          size: 10,
          parentId: this.parentId,
          categorySecond: this.categorySecond
        }).then((res) => {
          this.pagelist2 = res.data.records
          this.total = res.data.total
        })
      },
      chanePage(e) {
        this.current = e
        this.list2()
      }
    },

    mounted(){
      this.list()
      server.professional({
        parentId: null,
        categoryDepartment: null
      }).then((res) => {
        this.list4 = res.data
      })
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      .l{
        width: 1010px;
        background: #FFFFFF;
        .lT{
          width: 100%;
          border: 1px solid #EAEBEB;
          .list{
            display: flex;
            border-bottom: 1px solid #EAEBEB;
            li{
              cursor: pointer;
              font-size: 19px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: normal;
              color: #000000;
              line-height: 33px;
              margin-left: 40px;
              padding-top: 15px;
              p{
                width: 44px;
                height: 4px;
                background: rgba(0, 180, 247, 0);
                margin: 15px auto 0;
              }
            }
            li.active{
              p{
                background: #CB0E07;
              }
            }
          }
          .neirList{
            display: flex;
            flex-wrap: wrap;
            padding-left: 15px;
            margin-top: 20px;
            li{
              cursor: pointer;
              padding: 0 30px;
              height: 40px;
              line-height: 40px;
              background: rgba(0, 180, 247, 0);
              border-radius: 18px;
              margin-bottom: 10px;
              margin-left: 5px;
            }
            li.active{
              background: #CB0E07;
              color: #FFFFFF;

            }
          }
        }
        .lB{
          width: 100%;
          padding: 0 20px;
          li{
            border-bottom: 1px solid rgba(209, 213, 213, 1);
            display: flex;
            padding-bottom: 20px;
            margin-top: 20px;
            img{
              width: 200px;
               height: 125px;
            }
            div{
              padding: 10px 0;
              margin-left: 20px;
              width: calc(100% - 280px);
              h3{
                font-size: 22px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
              }
              p:nth-child(2){
                margin-bottom: 20px;
              }
              p{
                font-size: 16px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #B7BEBE;
                line-height: 32px;
              }
            }
          }
        }
        .page {
          padding: 30px;
          text-align: center;
        }
      }
      .r{
        width: calc(100% - 1030px);
        margin-left: 20px;
        background: #FFFFFF;
        border: 1px solid #EAEBEB;
        height: 745px;
        .lT{
          width: 100%;
          .list{
            margin-bottom: 10px;
            li{
              text-align: center;
              cursor: pointer;
              font-size: 19px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: normal;
              color: #000000;
              line-height: 33px;
              padding-top: 10px;
              p{
                width: 97px;
                height: 4px;
                background: rgba(0, 180, 247, 0);
                margin: 10px auto 0;
              }
            }
            li.active{
              p{
                background: rgba(0, 180, 247, 1);
              }
            }
          }
        }
        .lB{
          width: 100%;
          padding: 0 20px;
          li{
            border-bottom: 1px solid rgba(209, 213, 213, 1);
            display: flex;
            padding-bottom: 10px;
            margin: 10px 0;
            /*margin-bottom: 20px;*/
            img{
              width: 130px;
              height: 91px;
            }
            div{
              padding: 4px 0;
              margin-left: 10px;
              width: calc(100% - 140px);
              h3{
                font-size: 17px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                width: 100%;
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              p:nth-child(3){
                color: rgba(203, 14, 7, 1);
              }
              p{
                color: #B7BEBE;
                line-height: 32px;
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 750px) {

    .container {
      width: 100%;
      margin-top: 60px;
     .neir {
       display: block;
       .r {
         display: none;
       }
       .l {
         width: 100%;
         .lT {
           .list {
             li {
               font-size: 16px;
               margin-left: 20px;
             }
           }
           .neirList {
             li {
               padding: 0 10px;
               height: 30px;
               line-height: 30px;
             }
           }
         }

           .lB {
             li {
               padding-bottom: 15px;
               margin-top: 15px;
               img {
                 width: 125px;
                 height: 70px;
               }
               div {
                 padding: 0;
                 margin-left: 15px;
                 width: calc(100% - 140px);
                 .tit {
                   font-size: 16px;
                   padding-top: 5px;
                 }
                 .js {
                   font-size: 14px;
                   margin-bottom: 0 !important;
                 }
                 .time {

                 }
               }
             }

           }



       }
     }
    }
  }
</style>
